namespace Areas.Shared.Views {
    "use strict";

    const tabItems = [
        { id: 0, url: "/MyWorkflows/List/Review" },
        { id: 1, url: "/Workflows/List/Created" },
    ];

    export function tabInitialized(params: any) {
        return Areas.tabInitialized(tabItems)(params);
    }

}